import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterWithdrawalRequests from 'views/customers/financial/withdrawalRequests/filterWithdrawalRequest'; // Importing filter component for withdrawal requests
import TableWithdrawalRequest from 'views/customers/financial/withdrawalRequests/tableWithdrawalRequest'; // Importing table component for withdrawal requests
import DetailsWithdrawalRequest from 'views/customers/financial/withdrawalRequests/detailsWithdrawalRequests'; // Importing details component for withdrawal requests
import RecordWithdrawalRequest from 'views/customers/financial/withdrawalRequests/recordWithdrawalRequest'; // Importing record component for withdrawal requests
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal requests view.
 * @extends JetView
 */
export default class withdrawalRequestsView extends JetView {
    /**
     * Configures the layout of the withdrawal requests view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        const right = {
            // Right panel configuration
            type: 'wide',
            minWidth: 200,
            rows: [RecordWithdrawalRequest, DetailsWithdrawalRequest], // Components in the right panel
        };
        const right2 = {
            // Alternative right panel configuration for smaller screens
            height: 1,
            id: 'right2',
            width: screen.width - 54,
            type: 'wide',
            rows: [RecordWithdrawalRequest, DetailsWithdrawalRequest],
        };
        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            id: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                // Toolbar columns
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh data table
                        },
                    },
                },
                {
                    view: 'pager', // Pager configuration
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    animate: {
                        subtype: 'out',
                    },
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export dropdown
                    options: [
                        // Export options
                        { id: '1', value: 'Excel' },
                        { id: '2', value: 'PDF' },
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            var size = $$('datatable').getPager().config.size; // Get current page size
                            var page = $$('datatable').getPage(); // Get current page number
                            var first = size * page; // Calculate first index for export
                            var last = first + size - 1; // Calculate last index for export
                            if (value == 1) {
                                // If Excel export selected
                                var table = $$('datatable'); // Reference to data table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    // Loop through columns
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filter: function (obj) {
                                        // Filter for export
                                        return (
                                            $$('datatable').getIndexById(obj.id) >= first &&
                                            $$('datatable').getIndexById(obj.id) <= last
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Retiros',
                                    ignore: {
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                    footer: false,
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF export selected
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filter: function (obj) {
                                            // Filter for export
                                            return (
                                                $$('datatable').getIndexById(obj.id) >= first &&
                                                $$('datatable').getIndexById(obj.id) <= last
                                            );
                                        },
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Retiros',
                                        autowidth: true,
                                        ignore: {
                                            detailTittle: true,
                                            ActionTittle: true,
                                        },
                                        footer: false,
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };
        const left = {
            // Left panel configuration
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme,
                    id: 'toolbar-search',
                    elements: [
                        { view: 'label', label: _('Reporte de Retiros') }, // Title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search',
                            cols: [
                                {
                                    view: 'icon', // Search icon button
                                    icon: 'wxi-search',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        // Click event to show filter popup
                                        $$('filterPopup').show();
                                    },
                                },
                            ],
                        },
                    ],
                },
                FilterWithdrawalRequests, // Filter component
                TableWithdrawalRequest, // Table component
                toolbar, // Toolbar component
            ],
        };
        const avanc = {
            // Accordion for advanced details
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [
                { id: 'dColl', header: _('Detalles Avanzados'), body: right }, // Advanced details panel
            ],
        };
        webix.ui.fullScreen(); // Set full screen mode
        return {
            // Return the main layout configuration
            id: 'a5',
            type: 'clean',
            view: 'form',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        left, // Left panel
                        screen.width < 500 || screen.height < 500
                            ? right2 // Use alternative right panel for small screens
                            : avanc, // Use accordion for larger screens
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500 || screen.height < 500) {
                // Check for small screen
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[2]); // Remove the pager from the toolbar
                $$('pagerA').define('group', 1); // Define pager group
            }
            if (screen.width > 500 && screen.height > 500) {
                // Check for larger screen
                $$('toolbar-search').hide(); // Hide search toolbar
            }
            $.fn.scrollBottom = function () {
                // jQuery function to calculate scroll bottom
                return $(document).height() - this.scrollTop() - this.height();
            };
        });
    }
}

// FILE DOCUMENTED
